module.exports = __webpack_public_path__ + "img/feedback_check.f49fe5ca.png";